import { createContext, useContext } from 'react'

// Present only inside the public read-only project view (SCD-541). When set,
// shared components (e.g. SectionTaskTitle) build /share/<token>/task/<id> links
// instead of the authenticated in-app task route.
export const PublicShareContext = createContext<{ shareId: string } | null>(null)

export const usePublicShare = () => useContext(PublicShareContext)
